import { PatchManagementAvailableMaintenanceWindow, PatchManagementSearchableKeywords } from './patch-management.types';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';
import { MaintenanceWindowTypes } from '../../../../../../types/common/maintenanceWindowTypes';
import { RecurrenceOptions } from '../../../../../../types/common/schedulerTypes';
import { getTimezonedCurrentDateTimestamp } from '@nirvana/shared/time';
import { MaintenanceWindowSelectOption } from '../../../uiSettings/patchManagemnet/helpers/events/events';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { PatchManagementMaintenanceWindow, PatchManagementModule } from '@nirvana/shared/dtos/types/policies/common';

export const PATCH_MANAGEMENT_DEFAULT_VALUE: PatchManagementModule = {
  maintenanceWindows: [],
};

export function getDefaultUiSettingsForMaintenanceWindow() {
  return {
    type: MaintenanceWindowTypes.PATCH_MANAGEMENT,
    allowChangeByOtherUsers: true,
    specifics: {
      downloadSettings: {
        fallbackOnDirectDownload: true,
        cachingServers: [],
      },
      scanPatchesSettings: {
        enabled: true,
        useSameSchedule: false,
        useFallbackSchedule: false,
        runOnSystemChanges: true,
        scheduler: {
          recurrence: RecurrenceOptions.WEEKLY,
          startDate: getTimezonedCurrentDateTimestamp('UTC') - new Date().getTimezoneOffset() * 60,
          between: {
            startHour: 21,
            startMinute: 0,
            endHour: 23,
            endMinute: 59,
          },
          weeklyRecurrence: {
            every: 1,
            days: [0, 1, 2, 3, 4, 5, 6],
          },
        },
      },
      installPatchesSettings: {
        enabled: false,
        ifMissedRunAsSoonAsPossible: false,
        updateType: {
          securityPatchesSettings: {
            enabled: false,
          },
          nonSecurityPatchesSettings: {
            enabled: false,
          },
        },
        specificVendorAndProduct: {
          type: 1,
          enabled: false,
          vendorProductsPairs: [],
        },
      },
    },
  };
}

export function convertAvailableMaintenanceWindowsToDropdownOptions(
  maintenanceWindows: Array<PatchManagementAvailableMaintenanceWindow>
): Array<SelectOption> {
  return maintenanceWindows.map(maintenanceWindow => {
    return {
      value: maintenanceWindow._id,
      title: maintenanceWindow.name,
    };
  });
}

export function convertDropdownOptionsToMaintenanceWindows(
  selectedOptions: Array<MaintenanceWindowSelectOption>
): Array<PatchManagementMaintenanceWindow> {
  return selectedOptions.map(selectedOption => {
    return {
      id: selectedOption.value as string,
      name: selectedOption.title,
    };
  });
}

export function convertAvailableMaintenanceWindowsToSelectedMaintenanceWindows(
  maintenanceWindow: PatchManagementAvailableMaintenanceWindow
): PatchManagementMaintenanceWindow {
  return {
    id: maintenanceWindow._id,
    name: maintenanceWindow.name,
  };
}

// searchable keywords
export function getPatchManagementSearchableKeywords(): {
  [type in PatchManagementSearchableKeywords]: SearchableKeyword;
} {
  return {
    [PatchManagementSearchableKeywords.PatchManagement]: {
      translatedLabel: translateFn('Patch Management'),
      label: 'Patch Management',
    },
    [PatchManagementSearchableKeywords.PatchWindows]: {
      translatedLabel: translateFn('Maintenance windows'),
      label: 'Maintenance windows',
    },
    ...getPatchManagementRebootSearchableKeyword(),
  };
}
export function getPatchManagementRebootSearchableKeyword(): {
  [PatchManagementSearchableKeywords.PatchReboot]: SearchableKeyword;
} {
  return {
    [PatchManagementSearchableKeywords.PatchReboot]: {
      translatedLabel: translateFn('Reboot'),
      label: 'Reboot',
    },
  };
}
